import { render } from "./IndexPermission.vue?vue&type=template&id=c520bf72"
import script from "./IndexPermission.vue?vue&type=script&lang=js"
export * from "./IndexPermission.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__